import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { CommonMarginWrapper } from '../../styled';

export const Wrapper = styled(CommonMarginWrapper)`
  position: relative;
  max-width: 1005px;
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 0.5rem;
  }

  // reset layout CSS
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
  }
  p {
    margin-bottom: 1rem;
  }
`;

// Invisible, non-interactive overlay used only to measure how far the user
// scrolls through the rich content (split into three equally tall sections).
export const ScrollTrackingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  pointer-events: none;
  z-index: -1;
`;

export const SectionMarker = styled.div`
  flex: 1 1 0;
`;
